import React, { useContext, useEffect, useState } from 'react'
import UserEquity from '../components/User/UserFinances/UserEquity'
import UserBudget from '../components/User/UserFinances/UserBudget'
import AddBudgetMonthlyElement from '../components/User/UserBudget/AddBudgetMonthlyElement'
import { Link } from 'react-router-dom'
import StateContext from '../StateContext'
import { useQuery } from '../hooks/useQuery'

function ProfilePage() {

    const query = useQuery();

    const queryItem = query.get("item");
    const monthParam = query.get("month")
    const yearParam = query.get("year")

    const appState = useContext(StateContext)

    const [activeItem, setActiveItem] = useState(queryItem ? queryItem : "1")
    const [background, setBackground] = useState("bg-lightgrey")

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab);
        }
    }

    useEffect(() => {

        if (queryItem) {
            setActiveItem(queryItem)
        }

    }, [queryItem])

    return (
        <div className={background}>
            <div className={background === "bg-img" ? "mask rgba-black-light" : ""}>
                <div className="container py-3">
                    <Link to={`/member/edit/${appState.userId}`}><i className="fas fa-edit text-primary"></i></Link>
                    <div className="row">
                        <div className="col-4">
                            <Link to="/?item=1" onClick={() => toggle("1")} className={`btn btn-primary btn-sm btn-block ${activeItem === "1" && "active"}`}>Budsjett</Link>
                        </div>
                        <div className="col-4">
                            <Link to="/?item=2" onClick={() => toggle("2")} className={`btn btn-primary btn-sm btn-block ${activeItem === "2" && "active"}`}>Egenkapital</Link>
                            
                        </div>
                        <div className="col-4">
                            <Link to="/?item=3" onClick={() => toggle("3")} className={`btn btn-primary btn-sm btn-block ${activeItem === "3" && "active"}`}>Budsjettplanlegger</Link>
                        </div>
                    </div>
                    {activeItem === "1" && <UserBudget monthParam={monthParam} yearParam={yearParam} />}
                    {activeItem === "2" && <UserEquity />}
                    {activeItem === "3" && (
                        <React.Fragment>
                            <div className="card card-body mt-3">
                                <h2>Legg til månedlig budsjett (utgift)</h2>
                                <AddBudgetMonthlyElement type="expense" />
                            </div>
                            <div className="card card-body mt-3">
                                <h2>Legg til månedlig budsjett (inntekt)</h2>
                                <AddBudgetMonthlyElement type="expense" />
                            </div>
                        </React.Fragment>
                    )}
                    
                </div>
            </div>
        </div>
    )
}
export default ProfilePage